<div
  class="bmarkFwdRiskInstrumentContainer"
  [ngClass]="{
      'hidden-instrument': hidden,
      'visible-instrument': !hidden,
      'last-instrument-row': lastInstrumentRow,
    }"
>
  <span class="bm-instrument-label-container">{{instrument}}</span>
</div>
